import { FC, ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import Loader from './Loader'
import CustomTooltip from './custom-tooltip'

const buttonTypes = {
    squareBlue: 'text-white text-sm bg-custom_blue hover:bg-blue-800',
    squareYellow: 'text-white text-sm bg-custom_yellow hover:bg-yellow-400',
    roundedBlueBorder: 'text-blue-800 text-sm border border-blue-800 rounded-lg',
    squareGray: 'text-black bg-gray-200',
    full: 'w-full',
}

export type ButtonType = keyof typeof buttonTypes

interface ButtonProps {
    icon?: IconProp
    text: string
    type: ButtonType | ButtonType[]
    onClick?: () => void
    isLoading?: boolean
    preventSubmit?: boolean
    disabled?: boolean
    className?: string
    withoutSizing?: boolean
    tooltip?: ReactNode
    dataCy?: string
}

const Button: FC<ButtonProps> = ({
    icon,
    text,
    type,
    onClick,
    isLoading,
    preventSubmit = false,
    disabled = false,
    className,
    withoutSizing,
    tooltip,
    dataCy,
}) => {
    let classNames = ''

    if (Array.isArray(type)) {
        classNames = type.map((t) => buttonTypes[t]).join(' ')
    } else {
        classNames = buttonTypes[type]
    }

    return isLoading ? (
        <Loader />
    ) : (
        <CustomTooltip title={tooltip}>
            <button
                className={`font-bold text-base  outline-hidden leading-none max-tablet:text-sm max-tablet:leading-none ${classNames} ${className} ${
                    disabled && 'opacity-50'
                } ${!withoutSizing && 'pt-4 pb-3.5 px-8 max-lg:px-5 max-tablet:pt-3 max-tablet:pb-2.5'}`}
                onClick={onClick}
                type={preventSubmit ? 'button' : 'submit'}
                disabled={disabled}
                data-cy={dataCy}
            >
                {icon && <FontAwesomeIcon icon={icon as any} className="pr-2" size="1x" />}
                <span>{text}</span>
            </button>
        </CustomTooltip>
    )
}

export default Button
